import './Loding.css';
import loding from "../../assets/loding.gif"
const Loding = () =>{
 return(
    <span className='loding'>
       <img src={loding} /> Loding...
    </span>   
 )
}
export default Loding;